module.exports = "<main>\n    <div class=\"c-error-page\">\n        <h1 class=\"c-error-page__status-code\">{{$ctrl.statusCode}}</h1>\n        <h3 class=\"c-error-page__error\">{{$ctrl.error}}</h3>\n    </div>\n</main>";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/journey-ui/error/views/http.error.html
// module id = 924
// module chunks = 0